import React from "react";
import { createPortal } from "react-dom";
import { useScrollLock } from "Utils/useScrollLock";
import "Assets/css/Mdal.css";
import UseLangLstQuery from "Apis/LangTxtInqApi";

interface ApiResultModalProps {
    open: boolean;
    message: string;
    onClose: () => void;
    confirmText?: string;
    app?: string;
}

const ApiResultModal = ({ open, message, onClose, confirmText, app }: ApiResultModalProps) => {
    useScrollLock(open);
    const {isLoading,error,data: langData}:any = UseLangLstQuery( );
    const htmlMessage = (message || "").replace(/\n/g, "<br />");
    const isApp = (app || "").toLowerCase() === "app";
    confirmText = confirmText || (langData && langData.COMM_MAIN_CHK_MAIN_BTN_00);
    if (!open) {
        return null;
    }

    return createPortal(
        <div className='mdalCommWrap'>
            <div className='mdalBg' onClick={onClose}></div>
            <div className={`mdalCommContainer mdalCustomContainer ${isApp ? "appContainer" : ""}`.trim()}>
                <div className='mdalCommCloseBtn' onClick={onClose}><i className="close"></i></div>
                <div className="mdalCtxtInfo">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: htmlMessage,
                        }}
                    ></p>
                </div>
                <button className='mdalCommAgreeBtn' onClick={onClose}>
                    <p>{confirmText}</p>
                </button>
            </div>
        </div>,
        document.body
    );
};

export default ApiResultModal;
